const vn = {
  requirementList: 'Danh sách yêu cầu',
  material: 'Điều khiển vật chất',
  purchase: 'Mua sắm',
  prod: 'sản xuất"',
  finance: 'Tài chính',
  sale: 'doanh nghiệp"',
  materialStatus: 'Trạng thái kiểm tra vật chất',
  purchaseStatus: 'Tình trạng xét duyệt mua sắm',
  prodStatus: 'Tình trạng kiểm toán sản xuất',
  financeStatus: 'Tình trạng xét duyệt tài chính',
  saleStatus: 'Tình trạng kiểm toán doanh nghiệp',
  materialDesc: 'Ghi chú kiểm tra kiểm soát vật liệu',
  muaDesc: 'Nhận xét đánh giá mua hàng',
  prodDesc: 'Ghi chú đánh giá sản xuất',
  financeDesc: 'Ghi chú đánh giá tài chính',
  saleDesc: 'Ghi chú đánh giá doanh nghiệp',

  commodity: 'Sản phẩm',
  commodityStatus: 'Trạng thái xét duyệt sản phẩm',
  commodityDesc: 'Ghi chú xét duyệt sản phẩm',

  passed: 'đã được thông qua',
  notPass: 'Không thông qua',
  approvalTip: 'Vui lòng nhập ghi chú đánh giá',
  listSearchTip: 'Nhập số, mô tả, thông tin sản phẩm để tìm kiếm',

  number: 'Không',
  bomAmount: 'Số lượng sử dụng',
  requireCount: 'Số lượng cần thiết',
  itemCountInfo: 'Số lượng cần thiết',
  materialProgress: 'Tiến độ chuẩn bị vật liệu',
  mrd: 'Thời gian yêu cầu',
  plMrd: 'Vui lòng điền đầy đủ thời gian trước',
  mcPre: 'Số lượng sản phẩm kiểm soát',
  bomData: 'Tổng số tiêu chuẩn',
  estimatedCost: 'Ước tính chi phí',
  passStatus: 'Trạng thái phê duyệt',

  errorTip: 'Lời khuyên sai',
  errorDesc: 'Có dữ liệu bất thường trong bảng, bạn có chắc chắn không thực hiện cam kết sau khi sửa đổi không?',
  noRepl: 'Không có lựa chọn thay thế',
  selectRepl: 'Lựa chọn thay thế',
  allCount: 'Tổng số lượng đã được làm tròn lên, bạn có thể thay đổi tổng số lượng sử dụng theo tình hình thực tế',

  matchBom: 'Phù hợp với bảng Bom',
  editQuantity: 'Số sửa đổi',
  matchInventory: 'Phù hợp với hàng tồn kho',
  alrPreOutNum: 'Số lượng đã xuất kho trước',
  preOut: 'Kho dự trữ',
  confirmPickOut: 'Khi số lượng xuất kho trước lần này nhỏ hơn số lượng có thể xuất kho thực tế, phiếu lĩnh vật tư sẽ được tạo theo số lượng có thể xuất kho thực tế. Bạn có muốn tạo đơn xuất kho dự kiến không?',
  prePickOut: 'Tạo đơn xuất kho dự kiến',
  prePickOutNum: 'Số lượng xuất kho trước lần này',
  actualOutNum: 'Số lượng có thể xuất kho thực tế',
  addDesc: 'Thêm nhận xét',
  done: 'Hoàn thành',
  doneSuccess: 'Tạo danh sách yêu cầu thành công',
  doneSuccessTip: 'Danh sách các yêu cầu {{số}} đã được tạo và các doanh nghiệp liên quan sẽ tiếp tục các bước tiếp theo',
  next: 'Bước tiếp theo',
  previous: 'Bước trước',
  requirementAdd: 'Tạo một danh sách các yêu cầu',
  selectPro: 'Chọn sản phẩm',
  searchPro: 'Nhập truy vấn từ khóa sản phẩm',

  detail: 'Chi tiết danh sách yêu cầu',
  orderDetail: 'Chi tiết đơn hàng',

  purCount: 'Số lượng cần mua',
  purEdCount: 'Mua số lượng hàng đến',
  preInCount: 'Số lượng nhập kho trước',
  preOutCount: 'Số lượng trước khi xuất',
  minPrice: 'Đơn giá tối thiểu',
  maxPrice: 'Đơn giá tối đa',
  minCost: 'chi phí tối thiểu',
  maxCost: 'Chi phí tối đa',
  supplierAndPrice: 'Lựa chọn nhà cung cấp và giá cả',
  addPurDesc: 'Thêm mô tả mua hàng',

  notApproved: 'Chưa được phê duyệt',

  requireAppInfo: 'Thông tin xem xét danh sách yêu cầu',
  eps: 'Ngày phát hành dự kiến',
  plEps: 'Vui lòng điền vào thời gian online dự kiến',
  saveTemp: 'Lưu mẫu',
  saveTempSuccess: 'Đã thêm mẫu thành công',
  useQuantity: 'Số lượng sản phẩm sử dụng',
  addConfirm: 'Bạn có chắc chắn muốn thêm yêu cầu này?',
  selectProdPro: 'Chọn sản phẩm mẹ',
  plSelectProdPro: 'Vui lòng chọn mẫu bạn muốn sản xuất',
  product: 'Mẫu vật',
  prodCount: 'Số lượng sản xuất',
  plProdCount: 'Vui lòng nhập số lượng sản xuất',
  desc: 'Danh sách yêu cầu ghi chú',
  plDesc: 'Vui lòng nhập danh sách yêu cầu ghi chú',
  plSubPro: 'Chọn thông tin phụ',
  tempSuccess: 'Tạo template thành công',
  validError: "Kiểm tra lỗi",
  addRequirement: 'Thêm danh sách yêu cầu',
  total: 'Tổng số',
  success: 'Thành công',
  failed: 'Thất bại',
  exportExcel: 'Xuất Excel',
  requirementCreate: 'Tạo một danh sách các yêu cầu',
  mainInfo: 'Thông tin linh kiện chính',
  flow: "Dòng phê duyệt",
  delSubTip: 'Bạn có chắc chắn muốn loại bỏ các con được chọn? Không thể phục hồi sau khi xóa',
  syncClearRequirementItems: 'Đồng bộ xóa các mục yêu cầu',
  syncClearRequirementItemsTip: 'Bạn có chắc chắn muốn xóa tất cả các mục yêu cầu trong danh sách yêu cầu hiện tại không? Không thể khôi phục sau khi xóa',
  delOrderItemTip: 'Bạn có muốn xóa phiếu lĩnh vật liệu tương ứng không?',
  delPurchaseOrderItemTip: 'Bạn có muốn xóa đơn mua hàng tương ứng không?',
  selectAll: 'Chọn tất cả',
  oked: 'đã được thông qua',
  pending: 'Được tiến hành',
  rejected: 'Đã cự tuyệt',
  rejectTip: 'Bạn có chắc chắn muốn từ chối danh sách yêu cầu này? Sau khi từ chối, họ sẽ quay lại hoạt động kinh doanh trước đó',
  rejectReason: 'Lý do từ chối',
  rejectReasonRequired: 'Vui lòng nhập lý do từ chối',
  rejectReasonPlaceholder: 'Vui lòng giải thích chi tiết lý do từ chối...',
  rejectReasonMaxLength: 'Lý do từ chối không được vượt quá 500 ký tự',
  closeTip: 'Bạn có chắc chắn muốn lưu trữ danh sách yêu cầu này? Sau khi lưu trữ, dữ liệu sẽ không thể thay đổi.',
  supplier: "Nhà cung cấp",
  ert: 'Thời gian giao hàng dự kiến',
  supplierPriceNo: 'Không có nhà cung cấp giá tùy chọn',
  surOk: 'Thêm đơn hàng thành công, vui lòng lọc trang để xem',
  surSure: 'Vui lòng xác nhận có dữ liệu mua hàng',
  reject: 'Từ chối',
  close: 'Đóng cửa',
  saleNum: 'Số lượng bán hàng',
  prNum: 'Số lượng sản xuất',
  plPrNum: 'Vui lòng nhập số lượng sản xuất',
  orderAlready: 'Lệnh này đã tạo ra một yêu cầu',
  orderDate: "Ngày đặt hàng",
  pricePreview: ' Xem trước giá sản phẩm',
  endError: "Bạn có chắc chắn đơn hàng này đã được hoàn tất không?",
  plSeSupplier: "Chọn nhà cung cấp",
  plPlacePrice: "Chọn giá đơn hàng",
  noPurchaseTip: "Không có dữ liệu nào có sẵn để mua",
  okPurchase: "Xác nhận mua hàng",

  onKeyQutote: 'Một nút hỏi thăm.',
  subQutote: 'Truy vấn từng nhóm.',
  onKeyPrice: 'Một phím hỏi giá.',
  subPrice: 'Hỏi giá từng đợt.',
  onKeyPurchese: 'Một cú nhấp chuột để tạo đơn đặt hàng trước',
  sendQutote: "Yêu cầu đã được gửi",
  sendQutotePro: "Yêu cầu cho {{len}} dự án đã được gửi đi",
  ddl: 'Thời gian hết hạn.',
  noSupplier: 'Tạm thời không có nhà cung cấp nào có thể gửi đơn hỏi cung.',
  qutoteSednFail: "Gửi yêu cầu không thành công",
  autoPurcheseSucc: "Tự động tạo đơn đặt hàng trước thành công, một số vật liệu không thể tạo đơn đặt hàng trước mà không có báo giá hợp lệ",
  supplierProgress: "Tiến trình phản hồi của nhà cung cấp",
  unRead: "Chưa đọc",
  read: "Đã đọc",
  unPriced: 'Đang chờ báo giá.',
  resolved: "Báo giá",
  qutotationProgress: 'Chi tiết tiến độ hỏi giá.',
  matInfo: "Thông tin vật liệu",
  requirementInfo: "Thông tin báo giá",
  requirementHelp: "Hỗ trợ báo giá",
  supplierQuote: "Báo giá nhà cung cấp",
  status: 'Trạng thái.',
  days: "Chu kỳ cung cấp",
  mpq: "Đóng gói tối thiểu",
  supplierTime: 'Đủ thời gian.',
  edit: "Biên tập viên",
  resped: "Đã có phản hồi",
  unResp: 'Không có phản hồi.',
  rulePrice: "Giá hợp đồng",
  ruleDays: "Hợp đồng cung cấp chu kỳ",
  ruleMpq: "Hợp đồng đóng gói tối thiểu",
  price: 'Giá cả.',
  inputPrice: "Vui lòng nhập giá.",
  priceTip: 'Gợi ý: Báo giá cao hơn giá hợp đồng, có thể dẫn đến báo giá không có hiệu lực.',
  inputDays: "Vui lòng nhập chu kỳ cung cấp",
  daysTip: "Gợi ý: chu kỳ cung cấp lớn hơn chu kỳ cung cấp hợp đồng, có thể dẫn đến báo giá không hợp lệ.",
  mpqTip: "Gợi ý: Số lượng gói tối thiểu lớn hơn số lượng gói tối thiểu trong hợp đồng, có thể dẫn đến báo giá không hợp lệ.",
  inputSuppTime: 'Vui lòng nhập đủ thời gian.',
  addSuppQutoteTip: 'Nhà cung cấp này đã có đơn yêu cầu, không cần thêm mới.',
  addSuppQutote: "Báo giá nhà cung cấp mới",

  inputMpq: "Vui lòng nhập gói tối thiểu",
  ddlTime: "Thời gian giao hàng muộn nhất",
  inputDdlTime: "Vui lòng nhập thời gian giao hàng muộn nhất.",
  ddlTimeTip: "Gợi ý: Thời gian giao hàng muộn nhất vượt quá thời gian yêu cầu đầy đủ, thời gian quá hạn có thể dẫn đến báo giá không hợp lệ.",
  prevDMrd: "Thời gian giao hàng dự kiến",
  deadline: "Thời gian nộp bài muộn nhất",

  nuRead: "Chưa đọc",
  timedOut: "Đã quá hạn",
  day: "Trời",
  hour: "giờ",
  purTip: "Bạn có chắc chắn muốn tạo đơn đặt hàng trước không?",
  purContent: "Điều này sẽ tự động tạo ra một đơn đặt hàng trước khi mua",

  salePrice: "Số tiền bán hàng",
  mateCost: "Chi phí vật liệu",
  notCount: "Không tính toán",
  netProfit: "Lợi nhuận ròng",
  goPur: "Tạo đơn mua hàng",

  lazyQuota: 'Báo giá trễ',
  lazyQuotaSuc: 'Báo giá trì hoãn thành công',
  lazyQuotaErr: 'Báo giá trễ không thành công',
  lazyTime: 'Chọn hoặc nhập khoảng thời gian bạn muốn trì hoãn',
  curLazy: 'Thời hạn báo giá hiện tại',

  notSelect: 'Một số vật liệu không có báo giá hợp lệ, vui lòng đảm bảo rằng mỗi vật liệu tồn tại báo giá hợp lệ trước khi vượt qua',
  notSelectTip: 'Không có báo giá hợp lệ cho các vật liệu sau đây',
  purchaseProgress: "Tiến độ mua hàng",
  quotationProgress: "Tiến độ gửi yêu cầu",
  noQuotationTip: 'Không có báo giá hợp lệ cho vật liệu màu đỏ',
  searchPlaceHolder: 'Nhập yêu cầu về nhà cung cấp hoặc thông tin sản phẩm',
  allquotation: 'tất cả các câu hỏi',
  purchaseOrders: 'đơn đặt hàng',
  prePurchaseOrders: 'Đơn đặt hàng trước',
  preview: 'xem trước',
  toGen: 'được tạo ra',


  unapprove: 'được xem xét',
  approved: 'đã được kiểm toán',
  timed: 'Đã hết hạn',
  updatePrice: 'Thay đổi báo giá',
  rePrice: 'Báo giá lại',
  quotation: 'Phê duyệt báo giá',
  reSelect: 'Chọn thủ công',
  selected: 'Đã chọn',
  reSelecteDone: 'Đã chọn lại',
  reSelecteFail: 'Chọn lại thất bại',
  createPreOutInventory: 'Tạo một pre-library sheet',
  createPreOutInventoryCon: "Xác nhận tạo đơn xuất kho lĩnh vật tư?",
  createPreOutInventorySuccess: 'Tạo một pre-library order thành công',
  createPreOutInventoryFail: 'Lỗi tạo phiếu xuất bản trước',
  noPreOutInventory: 'Không có vật liệu xuất kho',
  pleaseSelect: 'Vui lòng chọn vật liệu',
  preOutInventory: 'Danh sách Pre-Library',
  goodsName: 'Tên vật liệu',
  availableQuantity: 'Số lượng thư viện có sẵn',
  outboundType: 'Loại đơn xuất bản',
  inCount: 'Số lượng vào kho',
  outCount: 'Số lượng thư viện',
  shouldOutCount: 'Số lượng cần xuất',
  actualOutCount: 'Số lượng xuất thực tế',
  requirmentQuantity: 'Số lượng đơn yêu cầu',
  preReadyGood: 'Vật liệu thường trực không cần xuất kho',
  outInventory: 'Danh sách xuất kho',
  notQuo: "Không cần báo giá",
  notPur: "Không cần mua hàng",
  curMrd: "Thời gian giao hàng hiện tại",
  selMrd: "Chọn thời gian giao hàng cuối cùng",
  finalMrd: "Thời gian giao hàng cuối cùng",
  mrdEdit: "Điều chỉnh thời gian giao hàng dự kiến",
  quoEdit: "Chỉnh sửa đơn thăm dò",
  closeReq: "Đóng đơn nhu cầu",
  editNum: "Sửa số lượng danh sách nhu cầu",
  plReqCount: "Vui lòng nhập số lượng cần thiết",
  plPurCount: "Vui lòng nhập số lượng cần mua",
  purCountErr: "Số lượng mua phải nhỏ hơn số lượng cần",
  bomAmountErr: "Vui lòng nhập số lượng BOM hợp lệ",
  quantityAndBomAmount: "Số lượng và lượng sử dụng không được để trống hoặc bằng 0",
  skipStock: "Bỏ qua khớp kho (không thực hiện xuất kho dự kiến)",
  skipMerge: "Hợp nhất vật liệu giống nhau (các vật liệu giống nhau được hợp nhất, số lượng được cộng dồn)",
  finalPurQuantity: "Số lượng mua hàng cuối cùng",
  quotationTip: "Báo giá không thể sửa sau khi gửi. Xác nhận gửi báo giá?",
  notAddCloseTip: "Chưa thêm nguyên liệu, bạn có chắc chắn muốn đóng?",
  confirmAddProduct: "Xác nhận thêm thông tin sản phẩm",
  duplicateMaterialTip: "Vật liệu được đánh dấu màu vàng biểu thị rằng có một vật liệu giống hệt khác",
  matching: "Đang khớp...",
  documentGenerationFailed: "Tạo tài liệu thất bại",
  printFailed: "In thất bại",
  pdfGenerationFailed: "Tạo PDF thất bại",
  requirementListAll: "Danh sách yêu cầu_Tất cả",
  exportMatchResult: "Xuất kết quả khớp",

  // MultiPurchaseSteps Đơn đặt hàng mua hàng hàng loạt
  multiPurchaseTitle: "Đơn đặt hàng mua hàng hàng loạt",
  selectSupplier: "Chọn nhà cung cấp",
  matchProduct: "Khớp sản phẩm",
  matchPrice: "Khớp giá",
  generatePurchase: "Tạo đơn đặt hàng mua hàng",
  acceptPurchase: "Chấp nhận đơn đặt hàng mua hàng",
  complete: "Hoàn thành",
  nextStep: "Tiếp theo",
  prevStep: "Trước",
  tip: "Mẹo",
  enterGenerateTip: "Không thể quay lại sau khi bước vào bước tạo đơn đặt hàng mua hàng",
  confirmClose: "Xác nhận đóng?",
  closeTipContent: "Đơn đặt hàng mua hàng chưa được tạo. Xác nhận đóng?",

  // MatchProduct Khớp sản phẩm
  oneClickAddProduct: "Thêm sản phẩm hàng loạt",
  addingProduct: "Đang thêm sản phẩm",
  processed: "Đã xử lý:",
  productsWithoutPrice: "Vật liệu được đánh dấu màu đỏ không tồn tại trong hệ thống nhà cung cấp. Bạn cần thêm các vật liệu này vào hệ thống nhà cung cấp",
  noNeedAddProduct: "Không cần thêm sản phẩm",
  noNeedAddProductDesc: "Không có vật liệu không tồn tại. Không cần thêm",
  supplierApiError: "Lỗi API nhà cung cấp, vui lòng kiểm tra",
  productMatchFailed: "Khớp sản phẩm thất bại",
  productMatchFailedDesc: "API nhà cung cấp:",
  successAddProduct: "Đã thêm thành công",
  productAddFailed: "sản phẩm, thất bại",
  oneClickAddPrice: "Thêm giá hàng loạt",
  addingPrice: "Đang thêm giá",
  productsWithoutPriceTip: "Vật liệu được đánh dấu màu đỏ không có giá trong hệ thống nhà cung cấp. Bạn cần thêm giá cho các vật liệu này vào hệ thống nhà cung cấp",
  noNeedAddPrice: "Không cần thêm giá",
  allProductsHavePrice: "Tất cả vật liệu đã có giá",
  supplierIdError: "Lỗi ID nhà cung cấp, vui lòng kiểm tra",
  successAddPrice: "Đã thêm thành công",
  priceAddFailed: "giá, thất bại",

  // GeneratePurchase Tạo đơn đặt hàng mua hàng
  oneClickOrder: "Đặt hàng hàng loạt",
  ordering: "Đang đặt hàng",
  successGeneratePurchase: "Đã tạo thành công",
  purchaseOrder: "đơn đặt hàng mua hàng",
  generatePurchaseFailed: "đơn đặt hàng mua hàng, thất bại",
  purchaseOrderNumber: "Số đơn đặt hàng mua hàng",
  purchaseQuantity: "Số lượng mua hàng",
  orderStatus: "Trạng thái đơn hàng",
  ordered: "Đã đặt hàng",
  finished: "Hoàn thành",
  notOrdered: "Chưa đặt hàng",
  acceptStatus: "Trạng thái chấp nhận",
  accepted: "Đã chấp nhận",
  oneClickAccept: "Chấp nhận hàng loạt",
  accepting: "Đang chấp nhận đơn đặt hàng mua hàng",
  noData: "Không có dữ liệu",
  noPurchaseOrderToAccept: "Không có đơn đặt hàng mua hàng nào để chấp nhận",
  successAccept: "Đã chấp nhận thành công",
  acceptFailed: "đơn đặt hàng mua hàng, thất bại",
  noPurchaseDataTip: "Dữ liệu không cần mua hoặc đã tạo đơn đặt hàng trước sẽ không được xử lý đặt hàng",
  swapSale: "Chuyển đơn",
  // SwapSaleOrder Chuyển đơn
  noDataToTransfer: "Không có dữ liệu để chuyển",
  noDataToTransferDesc: "Dữ liệu không cần mua hoặc đã tạo đơn đặt hàng trước sẽ không được chuyển",
  supplierApiLabel: "API nhà cung cấp: ",
  fetchOrgInfoFailed: "Không thể lấy thông tin tổ chức",
  orgLabel: "Tổ chức：",
  selectSupplierAndCustomer: "Vui lòng chọn tổ chức nhà cung cấp và khách hàng cuối cùng",
  noMatchedProductData: "Không có dữ liệu sản phẩm phù hợp",
  saleOrderTransferSuccess: "Chuyển đơn bán hàng thành công",
  saleOrderNumber: "Số đơn bán hàng: ",
  saleOrderGenerateFailed: "Tạo đơn bán hàng thất bại",
  selectSupplierFirst: "Vui lòng chọn nhà cung cấp",
  selectSupplierOrg: "Vui lòng chọn tổ chức nhà cung cấp",
  selectSupplierCustomer: "Vui lòng chọn khách hàng cuối cùng của nhà cung cấp",
  confirmGenerateSaleOrder: "Xác nhận tạo đơn bán hàng?",
  generateSaleOrderForSupplier: "Tạo đơn bán hàng cho nhà cung cấp: ",
  swapEnd: "Khớp thông tin thất bại, chuyển đơn đã kết thúc.",
  noCustomerPrice: "Vật liệu được đánh dấu đỏ không có giá khách hàng cuối này trong hệ thống nhà cung cấp",
  plAddCustomerPrice: "Vui lòng vào hệ thống nhà cung cấp để thêm giá vật liệu cho khách hàng cuối này",
  noProducts: "Vật liệu được đánh dấu đỏ không tồn tại trong hệ thống nhà cung cấp",
  plAddProdictOne: "1. Vào hệ thống nhà cung cấp để thêm thông tin các vật liệu này",
  plAddProdictTwo: "2. Vào hệ thống nhà cung cấp để thêm giá hàng hóa của các vật liệu này",
  closeSaleOrderTip: "Bạn có muốn xóa đơn bán hàng liên quan không:",
  plAddSupplierPrice: "Vật liệu được đánh dấu đỏ không có giá nhà cung cấp này. Vui lòng duy trì giá nhà cung cấp cho các vật liệu này trong hệ thống này trước.",
  batchSelect: "Chọn hàng loạt đơn thăm dò",
  progress: "Tiến độ",
  importQuotationExcel: "Nhập báo giá Excel",
  quotationImportPreview: "Xem trước nhập báo giá nhà cung cấp",
  quotationImportRowNumber: "Số dòng",
  quotationImportRequirementItemId: "ID mục yêu cầu",
  quotationImportSupplierCode: "Mã nhà cung cấp",
  quotationImportSupplierName: "Tên nhà cung cấp",
  quotationImportPrice: "Giá",
  quotationImportMpq: "Gói tối thiểu",
  quotationImportStatus: "Trạng thái",
  quotationImportItemIdRequired: "ID mục yêu cầu là bắt buộc",
  quotationImportItemNotFound: "ID mục yêu cầu không tồn tại hoặc đã hết hiệu lực",
  quotationImportProductMismatch: "ID mục yêu cầu không khớp mã tồn kho",
  quotationImportSupplierRequired: "Mã nhà cung cấp là bắt buộc",
  quotationImportSupplierLoadFailed: "Không thể tải dữ liệu nhà cung cấp",
  quotationImportPriceInvalid: "Giá phải là số hợp lệ lớn hơn 0",
  quotationImportMpqInvalid: "Gói tối thiểu phải là số hợp lệ lớn hơn 0",
  quotationImportNoMrd: "Yêu cầu chưa có MRD để xác định ngày giao hàng muộn nhất",
  quotationImportInvalidHeader: "Tiêu đề tệp không hợp lệ. Hãy dùng tệp xuất từ trang chi tiết hiện tại",
  quotationImportFileEmpty: "Tệp nhập không có dữ liệu để xử lý",
  quotationImportParseFailed: "Không thể phân tích tệp nhập",
  quotationImportSubmitFailed: "Không thể thêm báo giá nhà cung cấp",
  quotationImportReady: "Sẵn sàng",
  quotationImportReselect: "Chọn lại tệp",
  quotationImportHasErrors: "Có lỗi xác thực. Hãy sửa Excel và nhập lại",
  quotationImportSummary: "Thành công {{success}}, thất bại {{failed}}",
  salePass: "Chuyển thành đơn hàng chính thức",
  downloadTemplate: "Tải xuống mẫu",
  inputTemp: "Nhập từ mẫu",
  importTemplate: "Mẫu nhập danh sách yêu cầu",
  invalidTemplate: "Vui lòng chọn tệp mẫu đúng",
  parseDataSuccess: "Đã phân tích thành công {{count}} bản ghi",
  atLeastOnePreOutGreaterThanZero: "Ít nhất một số lượng xuất kho trước phải lớn hơn 0",
  cusOrderQty: "Số lượng đơn hàng khách hàng",
  cusOrderQtyTip: "Đơn chuyển",
  processFilter: "Tìm kiếm quy trình vật liệu",
  delErrTip: "Các vật liệu sau có số lượng đã xuất kho, không thể xóa!",
  mixReplaced: "Sử dụng kết hợp nguyên liệu thay thế",
  preOutDesc: "Ghi chú xuất kho dự kiến",
  prePickOutLimitAutoTip: "Số lượng xuất kho dự kiến hiện tại được tự động giới hạn trong phạm vi hợp lệ",
  prePickOutRemainLimit: "Số lượng xuất kho dự kiến còn lại",
  prePickOutStockLimit: "Số lượng tồn kho khả dụng",
  prePickOutMaxLimit: "Số lượng tối đa có thể nhập",
  deductOutCount: "Trừ số lượng đã xuất kho",
  inOrderDesc: "Ghi chú phiếu giao hàng",
  plInventoryDesc: "Vui lòng nhập ghi chú phiếu giao hàng",
  noSale: "Không có đơn bán hàng nguồn, không thể chuyển đơn", oldApprove: "Thứ tự duyệt cũ",
  newApprove: "Thứ tự duyệt mới",
  approveSaveTip: "Duyệt đơn thăm dò này sẽ đồng thời lưu thứ tự duyệt mới",
  approveRemark: "Ghi chú duyệt",
  matchLocType: "Loại vị trí khớp tồn kho",
  rematch: "Khớp tồn kho",
  rematchTip: "Loại vị trí khớp tồn kho đã được thay đổi. Vui lòng khớp lại tồn kho.",
  priceFloor: "Làm tròn giá đơn mua hàng",
  needReturn: "일부 출고 주문이 확인되었습니다!",
  needReturnTip: "Các đơn lĩnh vật tư chứa các vật liệu sau cần trả kho",
  bomDatax: "Dữ liệu BOM hệ thống",
  templeData: "Mẫu",
  xlsData: "Tệp BOM đơn bán hàng",
  dataTypeTip: "Chọn nguồn dữ liệu BOM để khớp",
  dataTypeErr: "Dữ liệu BOM của đơn bán hàng này phân tích bất thường",
  dataTypeErrTip: "Vui lòng kiểm tra dữ liệu BOM của đơn bán hàng này, hoặc chuyển sang nguồn dữ liệu BOM khác",
  pickErr: "Đơn xuất kho dự kiến mới: {{number}} phân bổ tồn kho thất bại, có giữ lại không?",
  pickErrTip: "Đơn xuất kho dự kiến: {{number}} đã tạo thành công",
  pickErrContent: "Vui lòng phân bổ tồn kho trong quản lý kho",
  pickErrDel: "Tạo đơn xuất kho dự kiến thất bại",
  itemDesc: "Ghi chú vật liệu",
  preOutErrTip: "Danh sách nhu cầu {{number}} đã tạo thành công, nhưng tạo đơn xuất kho dự kiến thất bại. Vui lòng thử lại!",
  rePreOutAdd: "Thử lại xuất kho dự kiến",
  failPreTip: "Tạo đơn xuất kho dự kiến cho đơn nhu cầu thất bại!",
  failPreTipDesc: "Tạo đơn xuất kho dự kiến thất bại sẽ khiến số lượng trong đơn nhu cầu bị sai! Nếu không xử lý lỗi tạo đơn xuất kho dự kiến, nên xóa đơn nhu cầu này và chạy lại!",
};

export default vn;
